// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as SectionTitle$Showside from "./SectionTitle.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EditorLayerItem$Showside from "./EditorLayerItem.bs.js";
import * as StylableElement$Showside from "./StylableElement.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
function SectionHeader(Props) {
  var category = Props.category;
  var linkLabel = Props.linkLabel;
  var linkHref = Props.linkHref;
  var showArrowOpt = Props.showArrow;
  var openLinkInNewTabOpt = Props.openLinkInNewTab;
  var minimalOpt = Props.minimal;
  var flushedOpt = Props.flushed;
  var overrideTitle = Props.overrideTitle;
  var renderTitle = Props.renderTitle;
  var renderDescription = Props.renderDescription;
  var contentBeforeTitle = Props.contentBeforeTitle;
  var contentAfterTitle = Props.contentAfterTitle;
  var layout = Props.layout;
  var customTitle = Props.customTitle;
  var onTitleClick = Props.onTitleClick;
  var onLinkClick = Props.onLinkClick;
  var showArrow = showArrowOpt !== undefined ? showArrowOpt : true;
  var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
  var minimal = minimalOpt !== undefined ? minimalOpt : false;
  var flushed = flushedOpt !== undefined ? flushedOpt : false;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = ViewportContext$Showside.use(undefined);
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var count = Belt_Option.map(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return connection.count;
  });
  var isConnected = Category$Showside.ExternalConnection.isConnectedToStoreCategory(category);
  var isCategoryActive = Caml_obj.equal({
    TAG: /* Category */0,
    _0: category.id
  }, match$2.listPageType);
  var onTitleClick$1 = onTitleClick !== undefined && (!isCategoryActive || isConnected) ? function (e) {
    Curry._1(onTitleClick, category);
  } : undefined;
  var onLinkClick$1 = onLinkClick !== undefined ? function (param) {
    Curry._1(onLinkClick, category);
  } : undefined;
  var match$3 = Category$Showside.Link.getCardFallbackLink(category);
  var href = linkHref !== undefined ? linkHref : match$3 !== undefined && match$3.TAG === /* URL */0 && Belt_Option.isNone(onLinkClick$1) ? match$3._0 : undefined;
  var canClickTitle = Belt_Option.isSome(onTitleClick$1);
  var canClickLink = Belt_Option.isSome(onLinkClick$1) || Belt_Option.isSome(href);
  var showArrow$1 = showArrow && canClickTitle;
  var onLinkClick$2 = function (e) {
    Curry.app(trackEvent, ["slider:see all link", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    Belt_Option.forEach(onLinkClick$1, function (callback) {
      Curry._1(callback, undefined);
    });
  };
  var linkTextSize = match$1.breakpoint >= 2 ? "text-xl" : "text-lg";
  var headingClassName = CSS$Showside.prefix(Cn.make(["group-2 inline-flex flex-col", canClickTitle ? "cursor-pointer" : ""]));
  var renderHeading = function (param) {
    var tmp = {
      minimal: minimal,
      showArrow: showArrow$1,
      text: Belt_Option.getWithDefault(overrideTitle, category.title)
    };
    if (onTitleClick$1 !== undefined) {
      tmp.onClick = Caml_option.valFromOption(onTitleClick$1);
    }
    return React.createElement(SectionTitle$Showside.make, tmp);
  };
  var renderDescription$1 = renderDescription !== undefined ? renderDescription : function (param) {
    var description = category.description;
    if (description !== undefined && !minimal && category.showDescription) {
      return React.createElement(DataAttribute$Showside.make, {
        dataTestId: "category-description",
        children: React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["line-clamp-2", "select-text", "text-lg", "text-secondary", "mt-2", "max-w-3xl"]))
        }, React.createElement(StylableElement$Showside.make, {
          className: "section__description",
          children: Curry._1(StringUtils$Showside.stripHTML, description)
        }))
      });
    } else {
      return null;
    }
  };
  var renderTitle$1 = renderTitle !== undefined ? renderTitle : function (param) {
    return React.createElement(EditorLayerItem$Showside.make, {
      kind: "section-title",
      nodeId: category.id,
      className: headingClassName,
      category: category,
      children: renderHeading(undefined)
    });
  };
  var renderLink = function (param) {
    if (linkLabel !== undefined && linkLabel !== "" && canClickLink) {
      var tmp = {
        children: React.createElement("span", {
          className: CSS$Showside.prefix(Cn.make(["flex items-center", linkTextSize]))
        }, React.createElement(StylableElement$Showside.make, {
          className: "section__link",
          children: null
        }, linkLabel, Belt_Option.mapWithDefault(count, "", function (c) {
          return " (" + String(c) + ")";
        }))),
        openLinkInNewTab: openLinkInNewTab,
        dataTestId: "clp-sectionheader-link",
        onClick: onLinkClick$2
      };
      if (href !== undefined) {
        tmp.href = Caml_option.valFromOption(href);
      }
      return React.createElement("div", {
        className: CSS$Showside.prefix("flex-grow flex justify-end font-button")
      }, React.createElement(Link$Showside.make, tmp));
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix("flex-grow flex justify-end")
    });
  };
  var style = Belt_Option.map(layout, function (layout) {
    if (layout.TAG === /* SliderLayout */0) {
      var slider = layout._0;
      var tmp = {};
      var tmp$1 = Belt_Option.map(slider.maxWidth, CSS$Showside.intToPx);
      if (tmp$1 !== undefined) {
        tmp.maxWidth = tmp$1;
      }
      var tmp$2 = Belt_Option.map(slider.padding, CSS$Showside.intToPx);
      if (tmp$2 !== undefined) {
        tmp.paddingRight = tmp$2;
      }
      var tmp$3 = Belt_Option.map(slider.padding, CSS$Showside.intToPx);
      if (tmp$3 !== undefined) {
        tmp.paddingLeft = tmp$3;
      }
      return tmp;
    }
    var grid = layout._0;
    var tmp$4 = {};
    var tmp$5 = Belt_Option.map(grid.maxWidth, CSS$Showside.intToPx);
    if (tmp$5 !== undefined) {
      tmp$4.maxWidth = tmp$5;
    }
    var tmp$6 = Belt_Option.map(grid.padding, CSS$Showside.intToPx);
    if (tmp$6 !== undefined) {
      tmp$4.paddingRight = tmp$6;
    }
    var tmp$7 = Belt_Option.map(grid.padding, CSS$Showside.intToPx);
    if (tmp$7 !== undefined) {
      tmp$4.paddingLeft = tmp$7;
    }
    return tmp$4;
  });
  if (customTitle !== undefined) {
    return Caml_option.valFromOption(customTitle);
  }
  var tmp = {
    className: CSS$Showside.prefix(Cn.make(["flex flex-col w-full mx-auto", flushed ? "" : match$1.isMobile ? "px-4" : "px-8"]))
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: category.showTitle && (Category$Showside.hasAnyItems(category) || Belt_Option.isSome(overrideTitle)),
    children: React.createElement(StylableElement$Showside.make, {
      className: "section__title-box",
      children: React.createElement(DataAttribute$Showside.make, {
        dataTestId: "clp-sectionheader",
        dataSectionId: category.id,
        children: React.createElement("div", {
          className: CSS$Showside.prefix("flex flex-col flex-grow"),
          role: "heading"
        }, React.createElement("div", tmp, React.createElement("div", {
          className: CSS$Showside.prefix("flex space-x-3 w-full items-center justify-end")
        }, React.createElement(ConditionalRender$Showside.WhenSome.make, {
          children: contentBeforeTitle
        }), Curry._1(renderTitle$1, undefined), renderLink(undefined), React.createElement(ConditionalRender$Showside.WhenSome.make, {
          children: contentAfterTitle
        })), Curry._1(renderDescription$1, undefined)))
      })
    })
  });
}
SectionHeader.displayName = "SectionHeader";
var make = React.memo(SectionHeader);
export { make };
/* make Not a pure module */